import { render, staticRenderFns } from "./ConfigQuickMessages.vue?vue&type=template&id=0c490e45"
import script from "./ConfigQuickMessages.vue?vue&type=script&lang=js"
export * from "./ConfigQuickMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports